import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck, Zap } from "lucide-react";
import Hero from "../components/Hero";
import Testimonials from "../components/Testimonials";
import ReviewsSection from "../components/ReviewsSection";
import ToolsBand from "../components/ToolsBand";
import ValuationReport from "../components/ValuationReport";
import PropertyCard from "../components/PropertyCard";
import BathShowcase from "../components/BathShowcase";
import AppShowcase from "../components/AppShowcase";
import FeaturedDevelopment from "../components/FeaturedDevelopment";
import Seo from "../components/Seo";
import { fetchProperties } from "../api";

const ValuationBand = () => (
  <section className="relative py-24 bg-[#1c1c1e] overflow-hidden">
    <div className="absolute inset-0 opacity-25">
      <img src="https://images.unsplash.com/photo-1550647512-8b8a24d4f646" alt="" className="w-full h-full object-cover" />
    </div>
    <div className="relative max-w-[820px] mx-auto px-5 text-center">
      <p className="text-[12px] tracking-[0.28em] uppercase text-[#d9b98a] mb-4">Free Instant Valuation</p>
      <h2 className="font-display text-white text-[32px] md:text-[44px] font-300 leading-tight mb-5">
        Get a free instant valuation for your property
      </h2>
      <p className="text-white/70 text-[15px] leading-relaxed max-w-[600px] mx-auto mb-9">
        Find out how much your home could be worth and uncover key insights about your property
        with our free, no-obligation valuation report in Bath &amp; Bristol.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <Link to="/services#valuation" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#b8935f] text-white text-[14px] font-500 hover:bg-[#a67f4d] transition-colors">
          <CalendarCheck size={17} /> Book a free Valuation
        </Link>
        <a href="#valuation" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/30 text-white text-[14px] font-500 hover:bg-white/10 transition-colors">
          <Zap size={17} /> Get an Instant Valuation
        </a>
      </div>
    </div>
  </section>
);

const RecentProperties = () => {
  const [tab, setTab] = useState("buying");
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const status = tab === "buying" ? "for-sale" : "to-rent";
    fetchProperties({ status, sort: "newest" })
      .then((data) => setProperties(data.slice(0, 6)))
      .catch(() => setProperties([]));
  }, [tab]);

  const filtered = properties;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3">Featured Listings</p>
            <h2 className="font-display text-[32px] md:text-[42px] font-300 text-[#2b2b2b]">Recently added properties</h2>
          </div>
          <div className="flex gap-2 bg-[#faf7f2] p-1.5 rounded-full border border-[#f0ece5] self-start">
            {["buying", "renting"].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-6 py-2.5 rounded-full text-[14px] capitalize transition-colors ${
                  tab === t ? "bg-[#b8935f] text-white" : "text-[#6a6a6a] hover:text-[#2b2b2b]"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {filtered.map((p) => (
            <PropertyCard key={p.id} property={p} />
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to={tab === "buying" ? "/buying" : "/lettings"}
            className="inline-flex items-center gap-2 text-[14px] font-500 text-[#b8935f] hover:gap-3 transition-all"
          >
            View all {tab === "buying" ? "properties for sale" : "properties to rent"} <ArrowRight size={17} />
          </Link>
        </div>
      </div>
    </section>
  );
};

const Home = () => {
  return (
    <div>
      <Seo
        path="/"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Anadear Estates",
          "url": "https://anadearestates.com/",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://anadearestates.com/buying?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        }}
      />
      <Hero />
      <ValuationBand />
      <BathShowcase />
      <Testimonials />
      <RecentProperties />
      <FeaturedDevelopment />
      <AppShowcase />
      <ToolsBand />
      <ReviewsSection />
      <ValuationReport />
    </div>
  );
};

export default Home;
